import { useEffect, useState } from "react";
import { useRabbitFestivalContext } from "../../../../hooks/festival-context";
import {
  FestivalCompetitionEventsDateList,
  FestivalCompetitionEventsItem,
  FestivalCompetitionEventsItemButton,
  FestivalCompetitionEventsItemInfo,
  FestivalCompetitionEventsItemInfoBox,
  FestivalCompetitionEventsItemTop,
  FestivalCompetitionEventsList,
  FestivalCompetitionEventsWrapper,
  FestivalCompetitionEventTap,
  FestivalCompetitionEventTapWrapper,
} from "./style";
import { MoneyInChip, PubTournament } from "../../../../../../../api/types";
import { formatDate } from "../../../../../../../utils/date";
import { event } from "jquery";

interface GroupedTournament {
  date: string;
  list: PubTournament[];
}

const RabbitFestivalCompetitionEvents = () => {
  const { events, handleEventPage } = useRabbitFestivalContext();
  const [groupedList, setGroupedList] = useState<GroupedTournament[]>([]);
  const [tab, setTab] = useState(0);

  useEffect(() => {
    const notEndEvents = events.filter((event) => !event.isEnd);
    if (notEndEvents.length === 0) {
      setTab(1);
    }
  }, []);

  useEffect(() => {
    if (!events.length) return;

    const map = new Map<string, PubTournament[]>();

    events.forEach((event) => {
      if (tab === 0 && event.isEnd) return;
      if (tab === 1 && !event.isEnd) return;
      const date = formatDate(event.startDate);
      if (!map.has(date)) {
        map.set(date, []);
      }
      map.get(date)!.push(event);
    });

    const result: GroupedTournament[] = Array.from(map, ([date, list]) => ({
      date,
      list,
    }));

    result.sort((a, b) => a.date.localeCompare(b.date));
    setGroupedList(result);
  }, [events, tab]);

  const getDate = (value: string) => {
    const [_, mm, dd] = value.split("-");
    return `${+mm}월 ${+dd}일`;
  };

  const getTime = (value: string) => {
    const date = new Date(value);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const isPM = hours >= 12;

    hours = hours % 12;
    if (hours === 0) hours = 12;

    if (minutes) {
      return `${isPM ? "오후" : "오전"} ${hours}시 ${minutes}분`;
    }
    return `${isPM ? "오후" : "오전"} ${hours}시`;
  };

  const getPrize = (moneyInChips: MoneyInChip[]) => {
    const totalValue = moneyInChips.reduce((sum, item) => sum + item.point, 0);

    return totalValue;
  };

  const getInfoList = (item: PubTournament) => {
    return [
      {
        name: "레지마감",
        value: `LV${item.registerDeadlineLevel}`,
      },
      {
        name: "바이인",
        value: `${((item?.buyIn || 0) / 10000)?.toLocaleString()} RABBIT`,
      },
      {
        name: "총상금",
        value: getPrize(item.moneyInChip).toLocaleString(),
      },
    ];
  };

  // 예약 가능 조건
  const canReservation = (item: PubTournament): boolean => {
    if (!item?.reservation || !item.timerDto) {
      return false;
    }

    // 현재 레벨 존재할 경우
    const currentLevel = item?.timeInfo?.currentLevel.level;
    if (currentLevel) {
      if (item?.registerDeadlineLevel >= currentLevel) {
        return true;
      }
    } else {
      // break일 경우
      const level = item?.timeInfo?.nextLevel?.level - 1;
      if (item?.registerDeadlineLevel >= level) {
        return true;
      }
    }

    return false;
  };

  return (
    <FestivalCompetitionEventsWrapper>
      <FestivalCompetitionEventTapWrapper>
        <FestivalCompetitionEventTap
          isSelect={tab === 0}
          onClick={() => setTab(0)}
        >
          진행중인 이벤트
        </FestivalCompetitionEventTap>
        <FestivalCompetitionEventTap
          isSelect={tab === 1}
          onClick={() => setTab(1)}
        >
          종료된 이벤트
        </FestivalCompetitionEventTap>
      </FestivalCompetitionEventTapWrapper>
      {groupedList.length === 0 ? (
        <div className="no-data">이벤트가 존재하지 않습니다. </div>
      ) : (
        groupedList.map((date, index) => (
          <FestivalCompetitionEventsDateList>
            <div className="title" key={index}>
              {getDate(date.date)}
            </div>
            <FestivalCompetitionEventsList>
              {date.list.map((item, i) => (
                <FestivalCompetitionEventsItem
                  key={i}
                  url={item.competition?.bannerImage}
                >
                  <div className="back" />
                  <FestivalCompetitionEventsItemTop>
                    <div className="time">{getTime(item.startDate)}</div>
                    <div className="title">
                      {item.title}
                      <br />
                      {item.subTitle}
                    </div>
                  </FestivalCompetitionEventsItemTop>
                  <FestivalCompetitionEventsItemInfo>
                    {getInfoList(item).map((info, idx) => (
                      <>
                        <FestivalCompetitionEventsItemInfoBox key={idx}>
                          <div className="name">{info.name}</div>
                          <div className="value">{info.value}</div>
                        </FestivalCompetitionEventsItemInfoBox>
                        {idx !== 2 && <div className="bar" />}
                      </>
                    ))}
                  </FestivalCompetitionEventsItemInfo>
                  <FestivalCompetitionEventsItemButton
                    isReservation={canReservation(item)}
                    onClick={() => handleEventPage(item.competition?.id || 0)}
                  >
                    {canReservation(item) ? "토너먼트 예약하기" : "자세히 보기"}
                  </FestivalCompetitionEventsItemButton>
                </FestivalCompetitionEventsItem>
              ))}
            </FestivalCompetitionEventsList>
          </FestivalCompetitionEventsDateList>
        ))
      )}
    </FestivalCompetitionEventsWrapper>
  );
};

export default RabbitFestivalCompetitionEvents;
